import { useMutation, useQueryClient } from '@tanstack/react-query';
import { showNotification } from '@mantine/notifications';
import { QUERY_KEYS } from '@/constants/queryKeys';
import { churchesService } from '@/services/churches.service';
import type { ChurchCreateRequest } from '@/types/churches';

export const useCreateChurchMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: ChurchCreateRequest) => churchesService.createChurch(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.CHURCHES] });
      showNotification({ title: 'Success', message: 'Organization created successfully', color: 'green' });
    },
  });
};
